/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {ConstructionTool} from '../../../../../common/models/construction-tool.model';

@Injectable({
    providedIn: 'root'
})
export class ConstructionToolModelService {
    title = 'ConstructionToolModelService';

    createActive = false;

    attrsMap = {};

    toolMap = {};

    selectedType = '';

    submittedMap = {};

    getToolAttrs(toolType: string) {
        if (!this.attrsMap[toolType]) {
            this.attrsMap[toolType] = [];
        }
        return this.attrsMap[toolType];
    }

    setToolAttrs(toolType: string, attrs: any[]) {
        const existingAttrs = this.getToolAttrs(toolType);
        existingAttrs.splice(0, existingAttrs.length, ...attrs);
    }

    clearToolAttrs(toolType: string) {
        this.getToolAttrs(toolType).length = 0;
    }

    clearAllToolsAttrs() {
        Object.keys(this.attrsMap).forEach(k => (this.attrsMap[k].length = 0));
    }

    getSelectedToolAttrs() {
        return this.selectedType ? this.getToolAttrs(this.selectedType) : [];
    }

    clearSelectedToolAttrs() {
        this.getSelectedToolAttrs().length = 0;
    }

    getTool(toolType: string): ConstructionTool {
        if (!this.toolMap[toolType]) {
            this.toolMap[toolType] = {};
        }
        return this.toolMap[toolType];
    }

    setTool(tool: ConstructionTool) {
        const existingTool = this.toolMap[tool.type];
        if (existingTool) {
            tool.errors.splice(0, tool.errors.length, ...existingTool.errors);
            tool.warnings.splice(0, tool.warnings.length, ...existingTool.warnings);
            tool.information.splice(0, tool.information.length, ...existingTool.information);
            tool.showErrors = existingTool.showErrors;
            tool.showWarnings = existingTool.showWarnings;
            tool.showInformation = existingTool.showInformation;
        }
        this.toolMap[tool.type] = tool;
    }

    getSelectedTool(): ConstructionTool {
        return this.selectedType && this.getTool(this.selectedType);
    }

    setSelectedTool(tool: ConstructionTool) {
        this.setTool(tool);
        this.selectedType = tool.type;
    }

    getSelectedToolType() {
        return this.selectedType;
    }

    clearAllErrorsAndWarnings() {
        Object.keys(this.toolMap).forEach(k => {
            const tool = this.toolMap[k] as ConstructionTool;
            tool.errors.length = 0;
            tool.warnings.length = 0;
            tool.showErrors = true;
            tool.showWarnings = true;
        });
    }

    setSubmitted(toolType: string, submitted: boolean) {
        this.submittedMap[toolType] = submitted;
    }

    getSubmitted(toolType: string) {
        return !!this.submittedMap[toolType];
    }

    clearAllSubmitted() {
        Object.keys(this.submittedMap).forEach(k => (this.submittedMap[k] = false));
    }

    getAttributesMap(toolType: string) {
        return this.getToolAttrs(toolType).reduce(
            (acc: any, attribute: {value?: any; prop?: any; parentAttribute?: any; showBasedOnParent?: any}) => {
                if (attribute.parentAttribute === null || this.isAttributeUnique(toolType, attribute)) {
                    acc[attribute.prop] = attribute.value;
                } else if (attribute.showBasedOnParent) {
                    acc[attribute.prop] = {id: `[${this.getParentAttribute(toolType, attribute.parentAttribute).value.id}]-${attribute.value}`};
                }
                return acc;
            },
            {}
        );
    }

    private isAttributeUnique(toolType: string, attribute: any) {
        return this.getToolAttrs(toolType).filter((a: any) => a.prop === attribute.prop).length === 1;
    }

    private getParentAttribute(toolType: string, property: string) {
        const parentAttribute = this.getToolAttrs(toolType).find((a: any) => a.prop === property);
        return parentAttribute?.value ? parentAttribute : undefined;
    }
}
